import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Button = styled(Link)`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -12px;
  padding: 0;
  border: 0;
  align-self: flex-start;
  color: inherit;
`;
